import { toast } from "react-toastify";
import {
  addBookedTripFailure,
  addBookedTripStart,
  addBookedTripSuccess,
  deleteBookedTripFailure,
  deleteBookedTripStart,
  editBookedTripFailure,
  editBookedTripStart,
  editBookedTripSuccess,
  fetchTripsFailure,
  fetchTripsStart,
  fetchTripsSuccess,
    fetchBillChargedTripsStart,
  fetchBillChargedTripsSuccess,
  fetchBillChargedTripsFailure,
} from "./reducer";
import {
  addBookedTripService,
  deleteBookedTripService,
  editBookedTripService,
  getTripsListService,
  getTripsBillChargedService,
} from "../../Services/TripService";

//thunk for fetch the category list
export const fetchTripsList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchTripsStart());
      const response = await getTripsListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchTripsSuccess({
            trips: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchTripsSuccess({
            trips: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchTripsFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchTripsFailure(error));
    }
  };

//thunk for the addig the category
export const fetchBillChargedTripsList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchBillChargedTripsStart());
      const response = await getTripsBillChargedService(params);

      const tripsArray = response.data; // already the array ✅

      if (Array.isArray(tripsArray)) {
        dispatch(
          fetchBillChargedTripsSuccess({
            trips: tripsArray,
            pagination: {
              totalPages: 1,
              totalElements: tripsArray.length,
              currentPage: 0,
              pageSize: tripsArray.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else {
        dispatch(fetchBillChargedTripsFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchBillChargedTripsFailure(error));
    }
  };
export const addBookedTrip = (requestParam) => async (dispatch) => {
  try {
    dispatch(addBookedTripStart());

    const response = await addBookedTripService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addBookedTripSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addBookedTripFailure("Failed to book trip"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addBookedTripFailure(error));      
  }
};


// // //this is the thunk for delete the category
export const deleteBookedTrip = (tripId) => async (dispatch) => {
  try {
    dispatch(deleteBookedTripStart());

    const response = await deleteBookedTripService(tripId);
    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteSuccess(tripId));
    } else {
      toast.error("Failed to delete Booked Trip");
      dispatch(deleteBookedTripFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteBookedTripFailure(error));
  }
};

// // //this tunk for the edit meal category
export const editBookedTrip = (requestParam) => async (dispatch) => {
  try {
    dispatch(editBookedTripStart());

    const response = await editBookedTripService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editBookedTripSuccess(response));
    } else {
      dispatch(editBookedTripFailure("Failed to update Booked Trip"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editBookedTripFailure(error));
  }
};

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
